var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"entrytypes"},[_c('EntryTypeList'),_c('EntryTypeCreate')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }